// extracted by mini-css-extract-plugin
module.exports = {"root":"NoLookBoardsModal_root__2wCwO","title":"NoLookBoardsModal_title__AImOj","border":"NoLookBoardsModal_border__20VOc"};